import type { SecuriteeBaseline } from '../api/securitee'

const STATES: Record<SecuriteeBaseline['checks'][number]['state'], { word: string; tone: string }> = {
  ok: { word: 'OK', tone: 'label-success' },
  fail: { word: 'Fail', tone: 'label-danger' },
  unknown: { word: 'Not reported', tone: 'label-default' },
  na: { word: 'Not applicable', tone: 'label-default' },
}

/** Configuratia de baza citita de agent (CyFun PR.PS-01.1), pe fila Summary a aparatului. */
export function DeviceBaseline({ baseline }: { baseline: SecuriteeBaseline | null }) {
  if (baseline === null) return null
  const failing = baseline.checks.filter((c) => c.state === 'fail').length

  return (
    <div className="row">
      <div className="col-md-12 divider">
        <h4 className="bordered">Security baseline</h4>
        <p className="text-muted">
          {failing} of {baseline.checks.length} checks fail · read {baseline.updated} by the agent · CyFun PR.PS-01.1
        </p>
      </div>
      <div className="col-md-12">
        <table className="table table-striped">
          <thead>
            <tr>
              <th>Check</th>
              <th>State</th>
              <th>Detail</th>
            </tr>
          </thead>
          <tbody>
            {baseline.checks.map((c) => (
              <tr key={c.key}>
                <td>{c.label}</td>
                <td>
                  <span className={`label ${STATES[c.state].tone}`}>{STATES[c.state].word}</span>
                </td>
                <td>{c.text}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
